export function isProjectSchema(data) {
  return data && data.componentsTree;
}